import { ExclamationCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Col, Form, message, Row, Space, Spin, Typography, Upload } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, FormProvider, useForm, useWatch } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Info } from "../../../../../../assets/svg";
import { maintenanceService } from "../../../../../../configs/constants";
import { FeatureToggle, useFeatureFlags } from "../../../../../../feature-flags";
import axios from "../../../../../../utils/axiosInceptor";
import { getSingleTicketMediaUpload, uniquiFileName } from "../../../../../../utils/fileUpload";
import { antdBeforeUploadAllowList } from "../../../../../../utils/uploadValidation";
import { UPLOAD_CONFIG } from "../../../../../libs/constants";
import {
  DateField,
  InputCheckbox,
  InputField,
  InputNumberField,
  ReactSelectField,
} from "../../../../../atoms/FormElement";
import {
  changeFieldFormatter,
  changeFieldParser,
  defaultMaintenancePreferredDateDays,
} from "../../../../BookingForm/components/utils";
import { getMaintenanceTypes } from "../../../../Configurations/ducks/actions";
import { getServiceProviders } from "../../../../ServiceProvider/ducks/actions";
import { getAvailablity, getOrgByID, getPropertyName, getPropertyUnits, getTicketType } from "../../ducks/actions";
import { AntTag } from "../OptionWithBadge";

var _ = require("lodash");
const { Text } = Typography;

const { Paragraph } = Typography;

const AddTicket = (props: any) => {
  const dispatch: any = useDispatch();

  const [submited, setSubmited] = useState(false);
  const [isError, setisError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [runVisible, setRunVisible] = useState(false);
  const ticketTypeApi = useSelector((state: any) => state.tickets.ticketsType);
  const [subTypes, setSubTypes] = useState([]);
  const organization = useSelector((state: any) => state.tickets.orgData);
  const availableSlots = useSelector((state: any) => state.tickets.availableSlots);
  const fetchPropertyUnitsApi = useSelector((state: any) => state.tickets.fetchPropertyUnits);
  const [ticketsType, setTicketType] = useState([]);
  const [propertiesList, setProperties] = useState([]);
  const [uploads, setUploads] = useState([]);
  const [slots, setSlots] = useState([]);

  const { isFeatureEnabled } = useFeatureFlags();
  const isPaidMaintenanceEnabled = isFeatureEnabled("14136-paid-maintenance");

  const defaultValues = {
    tickettype: "",
    requesttype: "regular",
    ticketsubtype: "",
    date: "",
    timeslot: "",
    desc: "",
    media: "",
    propertytype: "",
    mobile: "",
    unit_code: "",
    ...(isPaidMaintenanceEnabled ? { quantity: 1, amount: 0 } : {}),
    skipDateTime: false,
  };

  const methods = useForm({ defaultValues });
  const { control, handleSubmit, formState, reset, setValue } = methods;
  const { errors } = formState;

  const { properties } = useSelector((state: any) => state.service);

  const propertyRes = useSelector((state: any) => state.tickets.propertyname);
  const usertype = JSON.parse(window.localStorage.getItem("login-response"))?.usertype;

  useEffect(() => {
    if (usertype.length > 0) {
      if (!usertype.includes("serviceProvider")) {
        setProperties(properties);
      } else {
        setProperties(propertyRes);
      }
    }
  }, [usertype]);

  const handleChange = (e) => {
    setUploads(e.fileList);
  };

  const dummyRequest = (response) => {
    setTimeout(() => {
      response.onSuccess("ok");
    }, 0);
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  const onBack = () => {
    reset();
    setRunVisible(false);

    props.onCancel();
  };

  useEffect(() => {
    if (usertype.includes("serviceProvider")) {
      propertiesList.length === 0 && dispatch(getPropertyName());
    }
  }, [usertype]);

  const checktype: any = useWatch({ control, name: "tickettype" });
  const checksubtype: any = useWatch({ control, name: "ticketsubtype" });
  const datecheck: any = useWatch({ control, name: "date", defaultValue: "" });
  const propertyCheck: any = useWatch({ control, name: "propertytype" });
  const unit_code: any = useWatch({ control, name: "unit_code" });
  const requesttype: any = useWatch({ control, name: "requesttype" });
  const quantity = useWatch({ control, name: "quantity" });
  const skipDateTime = useWatch({ control, name: "skipDateTime" });

  useEffect(() => {
    const qty = Number(quantity) || 0;
    const unitAmount = Number(checksubtype?.amountWithVat) || 0;

    const calculatedTotal = qty * unitAmount;

    if (!isNaN(calculatedTotal)) {
      setValue("amount", calculatedTotal);
    }
  }, [quantity, checksubtype, setValue]);

  useEffect(() => {
    if (Object.keys(props?.parentTicket).length > 0) {
      let propertytypeValue: any = {
        value: props?.parentTicket?.propertyId,
        label: props?.parentTicket?.propertyName,
      };
      let unit_code: any = {
        value: props?.parentTicket?.unitId,
        label: props?.parentTicket?.unitCode,
      };
      setValue("propertytype", propertytypeValue);
      setValue("unit_code", unit_code);
    }
    dispatch(getMaintenanceTypes());
    dispatch(getServiceProviders());
  }, []);

  useEffect(() => {
    setValue("ticketsubtype", "");
    setValue("tickettype", "");

    if (usertype.includes("serviceProvider")) {
      const unit = fetchPropertyUnitsApi?.find((unit) => unit.unitId === unit_code.value);

      if (unit?.unit?.usagesType === "Commercial") {
        ticketTypeApi && setTicketType(ticketTypeApi?.commercialCategories);
        if (ticketTypeApi?.commercialCategories?.length == 0) setTicketType([]);
      }
      if (unit?.unit?.usagesType === "Residential") {
        ticketTypeApi && setTicketType(ticketTypeApi?.residentialCategories);
        if (ticketTypeApi?.residentialCategories?.length == 0) setTicketType([]);
      }
    } else {
      if (requesttype?.value === "internal") {
        ticketTypeApi && setTicketType(ticketTypeApi?.internalCategories);
        if (ticketTypeApi?.internalCategories?.length == 0) setTicketType([]);
      }
      if (requesttype?.value === "regular") {
        const unit = fetchPropertyUnitsApi?.find((unit) => unit.unitId === unit_code.value);

        if (unit?.unit?.usagesType === "Commercial") {
          ticketTypeApi && setTicketType(ticketTypeApi?.commercialCategories);
          if (ticketTypeApi?.commercialCategories?.length == 0) setTicketType([]);
        }
        if (unit?.unit?.usagesType === "Residential") {
          ticketTypeApi && setTicketType(ticketTypeApi?.residentialCategories);
          if (ticketTypeApi?.residentialCategories?.length == 0) setTicketType([]);
        }
      }
    }
  }, [requesttype, unit_code, ticketTypeApi]);

  useEffect(() => {
    if (checktype?.value) {
      setValue("ticketsubtype", "");
      const subCategories =
        ticketsType.find((item) => item.categoryId === checktype?.value)?.subCategory ||
        ticketsType.find((item) => item.categoryId === checktype?.value)?.subCategories;

      subCategories?.length > 0 && setSubTypes(subCategories);
    }
  }, [checktype]);

  useEffect(() => {
    if (checktype && moment(datecheck).isValid() && propertyCheck && checksubtype) {
      setValue("timeslot", "");

      const subType = subTypes.find((item) => item?.subCategoryId == checksubtype.value);
      const unit = fetchPropertyUnitsApi?.find((unit) => unit.unitId === unit_code.value);
      let ticketType;
      if (usertype.includes("serviceProvider")) {
        ticketType = "regular";
      } else {
        ticketType = requesttype?.value;
      }

      let body = {
        categoryId: checktype.value,
        startDate: dayjs(datecheck).format("YYYY-MM-DD"),
        propertyId: propertyCheck.value,
        timeInMin: subType?.timeInMin,
        unitType: unit?.unit?.usagesType?.toLowerCase(),
        ticketType: ticketType,
        subCategoryId: subType?.subCategoryId,
      };

      !organization?.rosterBypass && dispatch(getAvailablity(body));
    } else {
      setValue("timeslot", "");
      setSlots([]);
    }
  }, [checktype, datecheck, propertyCheck, checksubtype]);

  useEffect(() => {
    if (Object.keys(availableSlots)?.length > 0 && datecheck) {
      let date = dayjs(datecheck).format("YYYY-MM-DD");
      if (availableSlots[date]) setSlots(availableSlots[date]);
      else {
        setSlots([]);
        message.error("Unavailable, Please try further dates");
      }
    } else {
      setSlots([]);
    }
  }, [availableSlots]);

  useEffect(() => {
    if (propertyCheck) {
      setValue("ticketsubtype", "");
      setValue("tickettype", "");

      dispatch(getPropertyUnits(propertyCheck.value));

      const orgId = JSON.parse(window.localStorage.getItem("login-response"))?.orgId;

      if (propertyCheck?.value) {
        const param = {
          type: "addTicket",
          property: propertyCheck?.value,
        };
        dispatch(getTicketType(param));
      }

      if (propertyCheck?.value) {
        const propty = propertiesList?.find((e) => e?.propertyId == propertyCheck?.value);
        if (propty && propty?.orgId) dispatch(getOrgByID(propty?.orgId));
        else if (orgId && !organization?.maintenancePreferredDateDays) dispatch(getOrgByID(orgId));
      }
    }
  }, [propertyCheck]);

  const onFinish = async (values) => {
    setLoader(true);
    setSubmited(true);

    const normalizedUploads = [];
    const mediaAsset = [];

    uploads.forEach((e) =>
      normalizedUploads.push({
        ...e,
        modifiedName: uniquiFileName(e?.originFileObj.name),
      })
    );

    let noupload = false;

    await Promise.all(
      normalizedUploads.map(async (e, index) => {
        let res = null;
        res = await getSingleTicketMediaUpload(e.modifiedName, e.originFileObj);

        const doc = res?.result;
        if (doc)
          doc?.documentId &&
            mediaAsset.push({
              documentId: doc?.documentId,
              type: doc?.document?.type && doc?.document?.type?.toLowerCase(),
            });
        if (res == false) {
          noupload = true;
        }
      })
    );

    if (noupload) {
      setLoader(false);
      setisError(true);
      setErrorMessage("Media not Uploaded. Please Try again");
      return false;
    } else {
      let ticketType;
      if (usertype.includes("serviceProvider")) {
        ticketType = "regular"; //regular
      } else {
        ticketType = requesttype?.value; //
      }
      const subType = subTypes.find((item) => item?.subCategoryId == values?.ticketsubtype?.value);

      const unit = fetchPropertyUnitsApi?.find((unit) => unit.unitId === unit_code.value);

      const mainCategory = ticketsType?.find((item) => item?.categoryId === values?.tickettype?.value);

      const [startTime, endTime] = values?.timeslot?.value ? values?.timeslot?.value.split("-") : [null, null];

      const postJson = {
        ticketType: ticketType,
        unitType: unit?.unit?.usagesType?.toLowerCase(),
        unitId: values.unit_code.value,
        recurrenceId: false,
        category: {
          categoryId: values.tickettype.value,
          name: mainCategory?.name || mainCategory?.categoryName,
        },
        subCategory: {
          subCategoryId: values.ticketsubtype.value,
          name: subType?.name,
        },
        documents: mediaAsset,
        parentCaseId: props?.parentTicket ? props?.parentTicket?.ticketId : "",
        timeInMin: subType?.timeInMin,
        ticketUserType: "ServiceProvider",
        skipDateTime: values?.skipDateTime,
      };

      if (checksubtype?.paid) {
        postJson["recurrenceId"] = false;
        postJson["propertyName"] = values?.propertytype?.label || "";
        postJson["propertyId"] = values?.propertytype?.value || null;
        postJson["quantity"] = values?.quantity;
      }

      if (startTime && endTime) {
        postJson["preferredTimeStart"] = startTime;
        postJson["preferredTimeEnd"] = endTime;
      }

      if (values.date) {
        postJson["preferredDate"] = dayjs(values.date).format("YYYY-MM-DD"); //convert date to string
      }
      if (values?.desc) postJson["description"] = values?.desc;
      if (values?.mobile) postJson["alternateNumber"] = values?.mobile;

      const url = `${maintenanceService}/maintenance/${
        !checksubtype?.paid ? "portalCreateTicket" : "createPaidTicket"
      }`;

      try {
        await axios.post(url, postJson);
        setTimeout(() => {
          reset();
          setLoader(false);
          message.success("Ticket added successfully");
          setSubmited(false);
          props.setParentTicketId(null);
          props.onSubmit();
        }, 3000);
      } catch (e) {
        setLoader(false);
        setisError(true);
        const { response } = e;
        setErrorMessage(response?.data?.error);
      }
    }
  };

  function disabledDate(current) {
    let today = dayjs().format("YYYY-MM-DD");
    return (
      (current && dayjs(current).format("YYYY-MM-DD") < today) ||
      dayjs(today)
        .add(organization?.maintenancePreferredDateDays || defaultMaintenancePreferredDateDays, "day")
        .isBefore(current)
    );
  }

  return (
    <FormProvider {...methods}>
      <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
        {loader && !isError && (
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Space size={24} className="w-100 text-center" direction="vertical">
                <Spin size="large" className="ag-fontSize32" />
                {/* <Paragraph className="ag-default fontWeight6    00 mb-0">Loading</Paragraph> */}
              </Space>
            </Col>
          </Row>
        )}
        {!submited ? (
          <>
            <Row gutter={24}>
              <Col span={12}>
                <ReactSelectField
                  isRequired={true}
                  fieldname="propertytype"
                  label="Property"
                  control={control}
                  iProps={{
                    placeholder: "Select Property",
                    isDisabled: Object.keys(props?.parentTicket).length > 0,
                  }}
                  rules={{
                    required: "Please select Property",
                  }}
                  selectOption={
                    propertiesList?.length > 0 &&
                    propertiesList?.map((item) => ({
                      value: item?.propertyId || item?.value,
                      label: item?.buildingName || item?.label,
                    }))
                  }
                  validate={errors.propertytype && "error"}
                  validMessage={errors.propertytype && errors.propertytype.message}
                />
              </Col>
              <Col span={12}>
                <ReactSelectField
                  isRequired={true}
                  fieldname="unit_code"
                  label="Unit"
                  control={control}
                  iProps={{
                    placeholder: "Select unit code",
                    isDisabled: !fetchPropertyUnitsApi?.length || Object.keys(props?.parentTicket).length > 0,
                  }}
                  rules={{
                    required: "Please select unit code",
                  }}
                  selectOption={_.map(fetchPropertyUnitsApi, (item) => ({
                    value: item?.unitId,
                    label: item?.unit?.unitCode,
                  }))}
                  validate={errors.unit_code && "error"}
                  validMessage={errors.unit_code && errors.unit_code.message}
                />
              </Col>
            </Row>
            <Row gutter={24}>
              {!usertype.includes("serviceProvider") && (
                <Col span={12}>
                  <ReactSelectField
                    isRequired={true}
                    fieldname="requesttype"
                    label="Request Type"
                    control={control}
                    rules={{ required: "Please select Request Type" }}
                    selectOption={[
                      {
                        value: "internal",
                        label: "Internal",
                      },
                      {
                        value: "regular",
                        label: "Regular",
                      },
                    ]}
                    iProps={{
                      placeholder: "Select type",
                      isDisabled: !unit_code?.value,
                    }}
                    validate={errors.requesttype && "error"}
                    validMessage={errors.requesttype && errors.requesttype.message}
                    initValue=""
                  />
                </Col>
              )}
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <ReactSelectField
                  isRequired={true}
                  fieldname="tickettype"
                  label="Maintenance Type"
                  control={control}
                  rules={{ required: "Please select Maintenance Type" }}
                  selectOption={
                    (ticketsType &&
                      ticketsType?.map((item) => ({
                        value: item?.categoryId,
                        label: item?.name || item?.categoryName,
                      }))) ||
                    []
                  }
                  iProps={{
                    placeholder: "Select type",
                    isDisabled: !ticketsType?.length,
                  }}
                  validate={errors.tickettype && "error"}
                  validMessage={errors.tickettype && errors.tickettype.message}
                  initValue=""
                />
              </Col>
              <Col span={12}>
                <ReactSelectField
                  isRequired={true}
                  fieldname="ticketsubtype"
                  label={checksubtype?.paid ? <span>Sub-Type</span> : "Sub-Type"}
                  control={control}
                  iProps={{
                    placeholder: "Select Sub-Type",
                    isDisabled: !subTypes.length,
                  }}
                  rules={{
                    required: "Please select ticket sub-type",
                  }}
                  initValue=""
                  selectOption={subTypes?.map((item) => ({
                    value: item?.subCategoryId,
                    label: item?.name,
                    paid: item?.paid,
                    amountWithVat: item?.amount,
                  }))}
                  {...(isPaidMaintenanceEnabled ? { onChange: (e) => setValue("amount", e?.amountWithVat) } : {})}
                  formatOptionLabel={(option, { context }) => {
                    if (context === "value") {
                      return <span>{option.label}</span>;
                    }

                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span>{option.label}</span>
                        {option.paid && AntTag(option.amountWithVat)}{" "}
                      </div>
                    );
                  }}
                  validate={errors.ticketsubtype && "error"}
                  validMessage={errors.ticketsubtype && errors.ticketsubtype.message}
                  tooltip={
                    checksubtype?.amountWithVat > 0
                      ? {
                          title: `Amount to be paid: (AED ${checksubtype?.amountWithVat})`,
                          icon: <Info width="16px" height="16px" style={{ marginRight: "2px" }} />,
                        }
                      : undefined
                  }
                />
              </Col>
              <FeatureToggle flags="14136-paid-maintenance">
                {checksubtype?.paid && organization?.onSitePaymentForServices && (
                  <>
                    <Col span={12}>
                      <InputField
                        isRequired
                        label="Quantity"
                        fieldname="quantity"
                        control={control}
                        iProps={{
                          style: { borderRadius: 6, height: 40 },
                          type: "number",
                          min: 1,
                          formatter: (value) => changeFieldFormatter(value, "amount"),
                          parser: (value) => changeFieldParser(value, "amount"),
                        }}
                      />
                    </Col>

                    <Col span={12}>
                      <InputNumberField
                        isRequired
                        label="Amount (Incl. VAT)"
                        fieldname="amount"
                        control={control}
                        iProps={{
                          min: 0,
                          disabled: true,
                          formatter: (value) => changeFieldFormatter(value, "amount"),
                          parser: (value) => changeFieldParser(value, "amount"),
                        }}
                        formItemStyle={{ marginBottom: "1rem" }}
                        inputStyle={{ width: "100%" }}
                      />
                    </Col>
                  </>
                )}
              </FeatureToggle>

              {!organization?.rosterBypass && organization?.tenantSelectsVisitDateTime && (
                <Col span={24} className="mb-1">
                  <InputCheckbox fieldname="skipDateTime" label="Allow tenant to select date/time" control={control} />
                </Col>
              )}

              {!skipDateTime && (
                <>
                  <Col span={12}>
                    <DateField
                      fieldname="date"
                      label="Visit Date"
                      control={control}
                      iProps={{
                        placeholder: "DD-MM-YYYY",
                        format: "DD-MM-YYYY",
                        disabledDate: disabledDate,
                      }}
                      rules={{
                        required: "Please enter date",
                        setValueAs: (value) => moment(value).format("YYYY-MM-DD"),
                      }}
                      validate={errors.date && "error"}
                      validMessage={errors.date && errors.date.message}
                    />
                  </Col>

                  {!organization?.rosterBypass && (
                    <Col span={12}>
                      <ReactSelectField
                        isRequired
                        fieldname="timeslot"
                        label={`Time Slot ${slots.length > 0 ? "(available)" : ""}`}
                        control={control}
                        iProps={{ placeholder: "Select time" }}
                        rules={{ required: "Please select time" }}
                        selectOption={_.map(slots, (item) => ({ value: item, label: item }))}
                        validate={errors.timeslot && "error"}
                        validMessage={errors.timeslot && errors.timeslot.message}
                      />
                    </Col>
                  )}
                </>
              )}

              <Col span={12}>
                <InputField
                  fieldname="desc"
                  label="Additional Details"
                  control={control}
                  iProps={{ placeholder: "Enter Additional Details" }}
                  initValue=""
                />
              </Col>

              <Col span={12}>
                <InputField
                  label="Contact Number"
                  fieldname="mobile"
                  control={control}
                  initValue=""
                  iProps={{ addonBefore: "+971" }}
                  // isRequired={true}
                  validate={errors.mobile && "error"}
                  validMessage={errors.mobile && errors.mobile.message}
                  // disabled={disableAll}
                  rules={{
                    minLength: {
                      value: 9,
                      message: "Please enter valid contact number, 9 digits required",
                    },
                    maxLength: {
                      value: 9,
                      message: "Please enter valid contact number, 9 digits required",
                    },
                    // required: "Please enter Mobile No.",
                  }}
                />
              </Col>

              <Col span={24}>
                <Form.Item
                  className="mb-0"
                  validateStatus={errors.media && "error"}
                  help={errors.media && errors.media.message}
                >
                  <Controller
                    name="media"
                    control={control}
                    // rules={{ required: "Please select attachment" }}
                    render={({ field: { onChange, value } }) => {
                      return (
                        <Upload
                          listType="picture-card"
                          // fileList={value?.fileList}
                          onChange={(e) => {
                            onChange(e);
                            handleChange(e);
                          }}
                          multiple={true}
                          accept={UPLOAD_CONFIG.MEDIA.accept}
                          customRequest={dummyRequest}
                          beforeUpload={async (file: File) => {
                            return await antdBeforeUploadAllowList(
                              file,
                              UPLOAD_CONFIG.MEDIA,
                              (msg) => message.error(msg)
                            );
                          }}
                          onPreview={onPreview}
                          className="custom-upload mb-2"
                        >
                          <Space className="ag-success fontSize24" align="center">
                            <PlusCircleOutlined />
                            <Text className="ag-success RegularFont">Add Photo/Video</Text>
                          </Space>
                        </Upload>
                      );
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24} justify="space-between">
              <Col>
                <Button className="ag-gray-button-outline" onClick={onBack}>
                  Back
                </Button>
              </Col>
              <Col>
                <Button className="ag-green-button" htmlType="submit">
                  Add
                </Button>
              </Col>
            </Row>
          </>
        ) : (
          isError && (
            <>
              <Row gutter={[24, 24]}>
                <Col span={24}>
                  <Space size={24} className="w-100 text-center" direction="vertical">
                    <ExclamationCircleOutlined className="ag-fontSize32 ag-error" />
                    <Paragraph className="ag-error fontWeight600 mb-0">{errorMessage}</Paragraph>
                  </Space>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={24}>
                  <Button
                    className="ag-gray-button-outline"
                    htmlType="button"
                    onClick={() => {
                      setSubmited(false);
                      setisError(false);
                    }}
                  >
                    Back
                  </Button>
                </Col>
              </Row>
            </>
          )
        )}
      </Form>
    </FormProvider>
  );
};

export default React.memo(AddTicket);
